import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectReviewEntities } from '../EntitiesSelector';

const getReviewIds = state => state.getIn(['bibs', 'reviews', 'items'], Immutable.List());

export const selectReviews = createSelector([selectReviewEntities, getReviewIds], (reviewEntities, reviewIds) =>
  reviewIds.map(id => reviewEntities.get(id.toString()))
);

export default { selectReviews };
